/* eslint-disable no-restricted-globals */
import axios from 'axios';
import https from 'https';

const apiSSO = axios.create({
  baseURL: `/sso`,
  httpsAgent: new https.Agent({
    rejectUnauthorized: true,
  }),
});

export default apiSSO;
